/**
 * This module contains queries and mutations for greener units.
 */
import { gql } from 'graphql-request';

export const GREENER_UNITS_KEY = 'GREENER_UNITS_KEY';
export const GREENER_UNIT_KEY = (greenerUnitIdentifier) => [
  'project',
  'externalIdentifier',
  `${greenerUnitIdentifier}`,
];

export const READ_GREENER_UNITS = gql`
  query {
    greenerUnits {
      greenerUnitId
      externalIdentifier
      name
      description
      owningOrganisationObjectId
      defaultGreenerEye {
        greenerEyeId
        externalIdentifier
        name
      }
      watcherType {
        watcherTypeId
        externalIdentifier
        deviceType {
          deviceTypeId
          externalIdentifier
          consumesPower
          producesPower
        }
      }
      owningOrganisation {
        name
        organisationId
      }
    }
  }
`;

export const CREATE_GREENER_UNIT = gql`
  mutation ($greenerUnit: GreenerUnitInput!) {
    createGreenerUnit(greenerUnit: $greenerUnit) {
      greenerUnit {
        externalIdentifier
        name
        description
        owningOrganisationObjectId
        owningOrganisationId
        owningOrganisation {
          externalIdentifier
          name
        }
        watcherTypeId
        watcherType {
          deviceType {
            deviceTypeId
            externalIdentifier
            producesPower
            consumesPower
          }
        }
        defaultGreenerEyeId
        defaultGreenerEye {
          externalIdentifier
        }
      }
    }
  }
`;

export const UPDATE_GREENER_UNIT = gql`
  mutation ($greenerUnitId: Int!, $greenerUnit: GreenerUnitInput!) {
    updateGreenerUnit(greenerUnitId: $greenerUnitId, greenerUnit: $greenerUnit) {
      greenerUnit {
        externalIdentifier
        name
        description
        owningOrganisationObjectId
        owningOrganisationId
        owningOrganisation {
          externalIdentifier
          name
        }
        watcherTypeId
        watcherType {
          deviceType {
            deviceTypeId
            externalIdentifier
            producesPower
            consumesPower
          }
        }
        defaultGreenerEyeId
        defaultGreenerEye {
          externalIdentifier
        }
      }
    }
  }
`;

export const READ_GREENER_UNIT = gql`
  query getGreenerUnit($externalIdentifier: String!) {
    greenerUnit(externalIdentifier: $externalIdentifier) {
      greenerUnitId
      externalIdentifier
      name
      description
      owningOrganisationObjectId
      defaultGreenerEyeId
      watcherTypeId
      owningOrganisationId
      defaultGreenerEye {
        greenerEyeId
        externalIdentifier
        name
        description
        owningOrganisationId
      }
      watcherType {
        watcherTypeId
        externalIdentifier
        deviceType {
          deviceTypeId
          externalIdentifier
          consumesPower
          producesPower
        }
      }
      owningOrganisation {
        organisationId
        externalIdentifier
        name
        description
        mainContactId
        countryId
        parentOrganisation {
          organisationId
        }
      }
      latestProject {
        name
        externalIdentifier
      }
    }
  }
`;
